import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import user from "../redux/slices/userSlice";
import data from "../redux/slices/dataSlice";

export const store = configureStore({
  reducer: {
    user,
    data,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
